import { render, staticRenderFns } from "./Chart.vue?vue&type=template&id=4e48ccc8&scoped=true&"
import script from "./Chart.js?vue&type=script&lang=js&"
export * from "./Chart.js?vue&type=script&lang=js&"
import style0 from "./Chart.vue?vue&type=style&index=0&id=4e48ccc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e48ccc8",
  null
  
)

export default component.exports